import axios from "axios";
import { environment } from "../../environment";
import { clean, createFormData } from "../helpers/helpers";
import moment from "moment";

const CONTENT_URL = environment.contentUrl;

export const EventsService = () => {
  const getCourses = async () => {
    try {
      const path = environment.contentUrl + "events/courses";
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      throw err;
    }
  };

  const patchCourse = async (course: any, hcEventId: string) => {
    try {
      const path = environment.contentUrl + "events/courses/" + course.id;
      const res = await axios.patch(path, {
        name: course.name,
        description: course.description,
        start: course.start,
        end: course.end,
        duration: course.duration,
        hcEventId,
      });
      return res?.data;
    } catch (err) {
      throw err;
    }
  };

  const enrollUserToCourse = async (user: any, course: any) => {
    try {
      const path = environment.contentUrl + "events/courses/enroll";
      const res = await axios.post(path, {
        bbCourseId: course.id,
        hcUserId: user._id,
        hcUserEmail: user.email,
        bbUserId: user.bbUserId,
      });
      return res;
    } catch (err) {
      throw err;
    }
  };

  const unenrollUserFromCourse = async (bbUserId: any, bbCourseId: any) => {
    try {
      const path =
        environment.contentUrl +
        "events/courses/enroll/" +
        bbCourseId +
        "/" +
        bbUserId;
      const res = await axios.delete(path);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const getCourseMembers = async (bbCourseId: string) => {
    try {
      const path =
        environment.contentUrl + "events/courses/members/" + bbCourseId;
      const res = await axios.get(path);
      return res?.data ? res.data : [];
    } catch (err) {
      throw err;
    }
  };

  const getCourseContentAttachments = async (
    courseId: string,
    contentId: string
  ) => {
    try {
      const path =
        environment.contentUrl +
        "events/courses/content/" +
        courseId +
        "/" +
        contentId;
      const res = await axios.get(path);
      return res?.data ? res.data : [];
    } catch (err) {
      throw err;
    }
  };

  const syncEvents = async () => {
    try {
      const path = environment.authUrl + "sync/events";
      const res = await axios.get(path);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const getEventById = async (eventId: string) => {
    try {
      const path = environment.contentUrl + "event/item/" + eventId;
      const res = await axios.get(path);
      return res;
    } catch (err) {
      throw err;
    }
  };


  const syncSessions = async () => {
    try {
      const path = environment.authUrl + "sync/sessions";
      const res = await axios.get(path);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const getEventItems = async () => {
    try {
      const path = environment.contentUrl + 'event/items';
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      throw err
    }
  }

  const getEventAdminItems = async () => {
    try {
      const path = environment.contentUrl + 'event/events_for_admin';
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      throw err
    }
  }

  const filterEventItems = async (arg: string, param: string) => {
    try {
      const path = `${environment.contentUrl}event/filter_events_for_admin/${arg}/${param}`;
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      console.error("Error filtering events:", err);
      throw err;
    }
  }

  const postEventItem = async (postEventItem: { communityIds: string[], contentItemId: string, eventId: string }) => {
    try {
      const path = environment.contentUrl + 'event/items';
      const res = await axios.post(path, postEventItem);
      return res?.data;
    } catch (err) {
      throw err
    }
  }

  const deleteEvent = async (eventId: any) => {
    try {
      const path = environment.contentUrl + 'event/' + eventId._id;
      const res = await axios.delete(path);
      await updateDeleteEventInSFDC(eventId.sfSeminarId);
      return res?.data;
    } catch (err) {
      throw err
    }
  }

  const updateDeleteEventInSFDC = async (record: any) => {

    try {
      const path = environment.authUrl + "sf/update";
      const data = {
        update: {},
        subject: 'Program_Tier_2__c'
      };
      data.update = {
        Id: record,
        HN_Seminar_Type__c: null,
      };

      const res = axios.post(path, data)
        .then((response) => {
          console.log('success');
        }, (error) => {
          console.log(error);
        });
      return res;
    } catch (err) {
      throw err;
    }
  }



  const updateEvent = async (event: any) => {
    const path = `${CONTENT_URL}events`;
    const cleanEvent = clean(event);
    const formData = createFormData(cleanEvent);
    if (Array.isArray(event?.related) && event?.related.length === 0) {
      formData.append("related", JSON.stringify([]));
    }
    const res: any = await axios.patch(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
    await updateEventInSFDC(event);
    return res;
  }

  const updateEventInSFDC = async (record: any) => {

    try {
      const path = environment.authUrl + "sf/update";
      const data = {
        update: {},
        subject: 'Program_Tier_2__c'
      };
      data.update = {
        Id: record.sfSeminarId,
        HN_Event_title__c: record.eventTitle,
        HN_Event_desc__c: record.description,
        Seminar_Start_Date__c: record.dtStartDate ? moment(record.dtStartDate).format('yyyy-MM-DD') : null,
        Seminar_End_Date__c: record.dtEndDate ? moment(record.dtEndDate).format('yyyy-MM-DD') : null,
        Address_Street__c: record.address.street,
        Address_City__c: record.address.city,
        Address_State__c: record.address.state,
        Address_Zip__c: record.address.zip,
        Address_Country__c: record.address.country,
        Registration_URL__c: record.link,
        HN_Registration_URL__c: record.link,
        Seminar_Language__c: record.language === 'eng' ? 'English' : 'Hebrew',
      };

      const res = axios.post(path, data)
        .then((response) => {
          console.log('success');
        }, (error) => {
          console.log(error);
        });
      return res;
    } catch (err) {
      throw err;
    }
  }

  const getTaskNonCompleteParticipantsById = async (taskId: string, eventId: string) => {
    try {
      const path = `${environment.contentUrl}events/tasks/${taskId}/${eventId}/nonCompleteParticipants`;
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      throw err;
    }
  };

  return {
    postEventItem,
    getEventItems,
    getEventAdminItems,
    filterEventItems,
    getCourses,
    // createCourseByEvent,
    updateDeleteEventInSFDC,
    deleteEvent,
    patchCourse,
    enrollUserToCourse,
    unenrollUserFromCourse,
    getCourseMembers,
    getCourseContentAttachments,
    syncEvents,
    syncSessions,
    updateEvent,
    getEventById,
    getTaskNonCompleteParticipantsById,
  };
};